import React from "react";
import { formatCount } from "../../../utils/numberFormat";

const SummaryTableSection = ({ currentData }) => {

  return (
    <div className="lg:col-span-5">
      <div className="text-center mb-3">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Summary of Applications Received
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="px-4 py-3 text-left text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  District
                </th>
                <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Total Received
                </th>
                <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Qualified
                </th>
                <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Not Qualified
                </th>
                <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Cancelled
                </th>
              </tr>
            </thead>

            <tbody>
              {currentData && Object.keys(currentData.districtData).length > 0 ? (
                Object.entries(currentData.districtData).map(
                  ([district, data], index) => (
                    <tr
                      key={district}
                      className={`${
                        index % 2 === 0 ? "bg-[#F6F7F9]" : "bg-white"
                      } hover:bg-gray-100 transition-colors`}
                    >
                      <td className="px-4 py-3 text-left text-gray-800 border-b font-medium">
                        {district}
                      </td>

                      <td className="px-4 py-3 text-center text-gray-800 border-b font-semibold">
                        {formatCount(data.total)}
                      </td>

                      <td className="px-4 py-3 text-center text-gray-800 border-b font-semibold">
                        {formatCount(data.qualified)}
                      </td>

                      <td className="px-4 py-3 text-center text-gray-800 border-b font-semibold">
                        {formatCount(data.notQualified)}
                      </td>

                      <td className="px-4 py-3 text-center text-gray-800 border-b font-semibold">
                        {formatCount(data.cancelled || 0)}
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-4 py-8 text-center text-gray-500 border-b"
                  >
                    No data available
                  </td>
                </tr>
              )}

              {/* TOTAL ROW */}
              <tr className="bg-[#137e81] text-white font-bold">
                <td className="px-4 py-3 text-left border-b">Total</td>

                <td className="px-4 py-3 text-center border-b">
                  {formatCount(currentData?.total || 0)}
                </td>

                <td className="px-4 py-3 text-center border-b">
                  {formatCount(currentData?.qualified || 0)}
                </td>

                <td className="px-4 py-3 text-center border-b">
                  {formatCount(currentData?.notQualified || 0)}
                </td>

                <td className="px-4 py-3 text-center border-b">
                  {formatCount(
                    Object.values(currentData?.districtData || {}).reduce(
                      (sum, data) => sum + (data.cancelled || 0),
                      0
                    )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SummaryTableSection;
